var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoundation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9792 34.4302H24.8538C25.1283 34.4302 25.3915 34.5393 25.5856 34.7334C25.7797 34.9274 25.8887 35.1907 25.8887 35.4651C25.8887 35.7396 25.7797 36.0028 25.5856 36.1969C25.3915 36.391 25.1283 36.5 24.8538 36.5H15.0349C14.7604 36.5 14.4972 36.391 14.3031 36.1969C14.109 36.0028 14 35.7396 14 35.4651C14 35.1907 14.109 34.9274 14.3031 34.7334C14.4972 34.5393 14.7604 34.4302 15.0349 34.4302H18.9095V28.0885C18.6363 27.0371 17.2123 20.7864 20.1513 15.7444C23.2974 10.3382 30.1276 8.5996 30.4174 8.53337C30.6775 8.46508 30.9541 8.50249 31.1868 8.63744C31.4195 8.77239 31.5893 8.99392 31.6592 9.25365C31.742 9.54341 33.6048 16.3405 30.4587 21.7467C27.9005 26.1346 22.9165 28.105 20.9792 28.726V34.4302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundation);
export default __webpack_public_path__ + "static/media/Foundation.78703bb6c49e4cfd85586a9cc30a56ad.svg";
export { ForwardRef as ReactComponent };